import React, { useState } from 'react';
import { NavLink, useNavigate, Navigate } from 'react-router-dom';
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  InputGroup,
  Row,
  Spinner,
  Image
} from "react-bootstrap";
import style from './Login.module.css';
import { app } from '../../credenciales';
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { GoEye, GoEyeClosed } from "react-icons/go";
import { Toaster } from "sonner";
import { Alert } from "../../utils";
import { getFirestore, doc, getDoc } from 'firebase/firestore';
import imgLogo from "../../assets/images/ifh-logo.png";

const Login = () => {

  const db = getFirestore(app);
  const auth = getAuth(app);
  const navigate = useNavigate();
  const [loginFields, setLoginFields] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [role, setRole] = useState(null); // Estado para almacenar el rol del usuario
  const correoUsuario = sessionStorage.getItem("correo");

  const handleFormControl = (e) => {
    const { name, value } = e.target;
    setLoginFields({ ...loginFields, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!loginFields.email || !loginFields.password) return;
    setLoading(true);
    try {
      await signInWithEmailAndPassword(
        auth,
        loginFields.email,
        loginFields.password
      );

      try {
        const userDocRef = doc(db, 'usuarios', loginFields.email);
        const userDoc = await getDoc(userDocRef);

        if (userDoc.exists()) {
          const userData = userDoc.data();
          const userRole = userData.role;

          sessionStorage.setItem("userLoggedIn", true);
          sessionStorage.setItem("userRole", userRole);
          sessionStorage.setItem("correo", loginFields.email);

          if (userRole === "1") {
            //console.log(userRole);
            navigate(`/homeAdmin`);
          }
          else if (userRole === "2" || userRole === "3") {
            //console.log(userRole);
            navigate(`/homeAlumno`);
          }
        }
        setLoading(false); // Dejar de cargar
      } catch (error) {
        console.error('Error al obtener el rol del usuario:', error);
        setLoading(false);
      }

      // navigate(`/`);
    } catch (error) {
      setLoading(false);
      console.log(error.code);
      if (error.code === "auth/user-not-found") {
        Alert.error("No existe un usuario con ese correo");
      }
      if (error.code === "auth/invalid-credential") {
        Alert.error("Correo o constraseña incorrectos");
      }

      //return Alert.error(error.code);
    }
  };

  const handleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <Container fluid={true} className={style.loginContainer}>
      <Row className='d-flex justify-content-center text-center mb-4'>
        <Col>
          <Image src={imgLogo} className={style.imgLogo} />
        </Col>
      </Row>
      <Row className='d-flex justify-content-center'>
        <Col className={style.colContainer} md={4} sm={12}>
          <div className='text-center'>
            <h3 className={style.title}>¡Nos alegra verte otra vez!</h3>
            <p className={style.text}>Accede a tu cuenta</p>
          </div>
          <Form onSubmit={handleSubmit} className="mt-4">
            <Form.Group className="mb-3" controlId="formBasicEmail">
              {/* <Form.Label className={style.formLabels}>Email</Form.Label> */}
              <Form.Control
                isInvalid={
                  loginFields.email.length > 0 &&
                  !loginFields.email.match(
                    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                  )
                }
                type="email"
                placeholder="Email"
                name="email"
                value={loginFields.email}
                onChange={handleFormControl}
                className={style.formInputs}
              />
              <Form.Control.Feedback type="invalid">
                {("Debes escribir un correo válido")}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicPassword">
              {/*  <Form.Label className={style.formLabels}>
                {("Contraseña")}
              </Form.Label> */}
              <InputGroup>
                <Form.Control
                  isInvalid={
                    loginFields.password.length > 0 &&
                    loginFields.password.length < 6
                  }
                  type={showPassword ? "text" : "password"}
                  placeholder="Contraseña"
                  name="password"
                  value={loginFields.password}
                  onChange={handleFormControl}
                  className={style.formInputs}
                />
                {showPassword ? (
                  <Button
                    className={style.showPswBtn}
                    variant="dark"
                    onClick={handleShowPassword}
                  >
                    <GoEye />
                  </Button>
                ) : (
                  <Button
                    className={style.showPswBtn}
                    variant="dark"
                    onClick={handleShowPassword}
                  >
                    <GoEyeClosed />
                  </Button>
                )}
                <Form.Control.Feedback type="invalid">
                  {("Minimo 6 caracteres")}
                </Form.Control.Feedback>
              </InputGroup>
            </Form.Group>
            <Button type="submit" className={style.loginBtn}>
              {("Ingresar")}{" "}
              {loading && (
                <Spinner
                  as="span"
                  size="sm"
                  animation="grow"
                  role="status"
                />
              )}
            </Button>
          </Form>
          <div className='mt-2'>
            <NavLink to="/recuperarContraseña" className={`${style.resetPasswordTxt}`}>
              <span className={style.registerSignupTxt}>¿Olvidaste tu contraseña?</span>
            </NavLink>
          </div>
          <div className='text-center mt-4'>
            <NavLink to="/signUp" className={`${style.register}`}>
              ¿No tenés una cuenta? {" "}
              <span className={style.registerSignupTxt}>Registrate ahora</span>
            </NavLink>
          </div>
          <Toaster richColors position="bottom-center" />
        </Col>
      </Row>
    </Container>
  )

}

export default Login;